import React from "react";
import PageHeaderComponent from "../../components/page-components/page-header.component";
import { Typography, Box } from "@material-ui/core";

const ImpressumPage = () => (
  <div>
    <PageHeaderComponent title="Impressum und Nutzungsbedingungen" />
    <Typography variant="body1">
      Das vorliegende Spieleangebot "Ideen säen" mit der URL{" "}
      <a href="https://ideen-saeen.web.app">ideen-saeen.web.app</a> ist ein
      Angebot für die Gemeinden des katholischen Dekanats Wetterau-West.
    </Typography>
    <Box mt={2}>
      <Typography variant="h5">Dekanat Wetterau-West</Typography>
    </Box>
    <Box mt={2}>
      <Typography variant="body1">
        vertreten durch Dekan Stefan Wanske
        <br />
        Dekanat Wetterau-West
        <br />
        Karlstraße 35
        <br />
        61231 Bad Nauheim
        <br />
        <br />
        Tel: 06032-931313
        <br />
        Fax: 06032-931312
        <br />
        <br />
        E-Mail:{" "}
        <a href="mailto:wetterau-west@kirche-wetterau.de">
          wetterau-west@kirche-wetterau.de
        </a>
        <br />
        <br />
        Das auf der Webseite des Dekanats (
        <a href="www.katholische-kirche-wetterau.de">
          www.katholische-kirche-wetterau.de
        </a>
        ) hinterlegte Impressum und die Nutzungsbedingungen gelten für „Ideen
        säen“ analog.
        <br />
        <br />
        Die dort hinterlegte Datenschutzerklärung gilt analog.
        <br />
        <br />
        Darüber hinaus ist für „Ideen säen“ mit der URL{" "}
        <a href="https://ideen-saeen.web.app">ideen-saeen.web.app</a>
        <br />
        Herr Stefan Glaum (
        <a href="mailto:technik.ideen-saeen@kirche-wetterau.de">
          technik.ideen-saeen@kirche-wetterau.de
        </a>
        ) technisch verantwortlich.
      </Typography>
    </Box>
  </div>
);

export default ImpressumPage;
